import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getProducts, getGalleryBySlug } from '../lib/cms';
import useSEO from '../hooks/useSEO';
import GalleryLightbox from '../components/GalleryLightbox';

export default function Forside() {
  useSEO(
    'Chokolenten ApS | Håndlavet chokolade & søde sager i Hanstholm',
    'Chokolenten ApS i Hanstholm laver hjemmelavet chokolade, store lækre Thy Kukies, kager, personlige gavekurve og søde specialiteter med fokus på godt håndværk og hyggelig caféstemning.'
  );

  const [galleryImages] = useState([
    'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-93-707867284-1596268992501877-3831309819476516639-n.jpg',
    'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-93-708558327-1596268989168544-4001724096145647304-n.jpg',
    'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-93-711135925-1598139312314845-9131132090530461921-n.jpg',
    'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-217-572780084-1407548518040593-6115900561181048869-n.jpg'
  ]);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const categories = [
    {
      name: 'Chokolade',
      slug: 'chokolade',
      desc: 'Vores store udvalg af håndlavet chokolade, herunder chokoladeplader, chokoladeposer, vores populære chokoladefrøer, tørret mango med chokolade og fyldte chokolader.',
      image: 'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/plade-ma-rk-blandet-na-dder.jpg'
    },
    {
      name: 'Thy Kukies',
      slug: 'thy-kukies',
      desc: 'Store, lækre Thy Kukies med masser af chokolade, bagt med fokus på det gode håndværk.',
      image: 'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/thykukies1_1.png'
    },
    {
      name: 'Kager',
      slug: 'kager',
      desc: 'Lækre kager bagt med omhu og råvarer af højeste kvalitet.',
      image: 'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/img-2839.jpg'
    },
    {
      name: 'Gaveæsker & Gavekurve',
      slug: 'gaveaesker-gavekurve',
      desc: 'Vi laver gaveæsker og gavekurve til private og erhverv i alle størrelser og sammensætninger. Byg selv eller vælg fra butikkens udvalg.',
      image: 'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-93-711709435-1598139275648182-966955307337855336-n.jpg'
    },
    {
      name: 'Sæsonvarer',
      slug: 'saesonvarer',
      desc: 'Sæsonens lækkerier til højtider samt cremet gourmet-is fra Kastberg (fra påske til efterårsferien).',
      image: 'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/chokolenten-logo.png'
    }
  ];

  // Instagram/Facebook fiktive opslag til social sektion
  const socialPosts = [
    {
      id: 1,
      platform: 'instagram',
      icon: 'fa-instagram',
      text: 'Friskbagte Thy Kukies direkte fra ovnen! 🍪 Vi har fyldt montren op med Triple Chocolate og Karamel & Macadamia i dag. Ses vi på Bytorvet?',
      image: 'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-93-708558327-1596268989168544-4001724096145647304-n.jpg',
      likes: 142
    },
    {
      id: 2,
      platform: 'facebook',
      icon: 'fa-facebook',
      text: 'Vi forbereder sommerens lækreste chokoladehjerter! 🍓 Håndlavet med hvid chokolade og frysetørrede bær. Perfekt som værtindegave eller selvforkælelse.',
      image: 'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-93-711135925-1598139312314845-9131132090530461921-n.jpg',
      likes: 89
    },
    {
      id: 3,
      platform: 'instagram',
      icon: 'fa-instagram',
      text: 'Bag kulisserne: To passionerede søstre, masser af chokolade og højt humør! 👩‍🍳👩‍🍳 Hver eneste chokolade er tempereret og dekoreret i hånden med fokus på det gode håndværk.',
      image: 'https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-93-711709435-1598139275648182-966955307337855336-n.jpg',
      likes: 215
    }
  ];



  return (
    <div className="flex flex-col gap-20 pb-0">
      
      {/* 1. HERO SEKTION */}
      <section className="relative min-h-[80vh] flex items-center justify-center bg-choc-dark text-cream-light overflow-hidden">
        {/* Baggrundsbillede med mørkt overlay */}
        <div className="absolute inset-0">
          <img
            src="https://assets.auxodev.dk/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-117-693556591-1580201547441955-3363968098443594962-n.jpg"
            alt="Håndlavet chokolade"
            className="w-full h-full object-cover opacity-60 scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-choc-dark/50 via-choc-dark/20 to-transparent" />
        </div>

        {/* Indhold */}
        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center flex flex-col items-center gap-6">
          <span className="text-xs sm:text-sm font-sans uppercase tracking-[0.3em] text-berry-light font-bold bg-berry-accent/20 px-4 py-1.5 rounded-full border border-berry-accent/30">
            Lokalt håndværk fra Hanstholm
          </span>
          <h1 className="text-4xl sm:text-6xl md:text-7xl font-serif font-bold text-cream-light leading-tight tracking-wide drop-shadow-sm">
            Lidt ekstra at <br />
            <span className="text-caramel-light italic">glæde sig over</span>
          </h1>
          <p className="max-w-2xl text-base sm:text-lg text-cream-light/80 leading-relaxed font-sans">
            Fra hverdagens små fristelser til livets store øjeblikke. Hos Chokolenten finder du håndlavet chokolade, lækre specialiteter og personlige gavekurve – perfekte til både privat forkælelse, firmaforkælelse og gaver, der gør indtryk.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center gap-4 mt-4 w-full sm:w-auto">
            <Link
              to="/produkter/chokolade"
              className="w-full sm:w-auto bg-berry-accent hover:bg-berry-accent/90 text-white font-sans font-semibold px-8 py-4 rounded-xl transition-all shadow-lg hover:shadow-xl cursor-pointer text-center"
            >
              Se vores udvalg
            </Link>
            <Link
              to="/kontakt"
              className="w-full sm:w-auto bg-transparent hover:bg-cream-light/10 text-cream-light border border-cream-light/30 font-sans font-semibold px-8 py-4 rounded-xl transition-all cursor-pointer text-center"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>

      {/* 2. INTRODUKTION (OM OS PREVIEW) */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 relative">
            <div className="absolute -inset-4 bg-berry-accent/5 rounded-3xl -rotate-2" />
            <img
              src="https://assets.auxodev.dk/cdn-cgi/image/width=800,quality=85,format=auto/assets/2c62fa2f-a0e0-45c6-84dc-1b9d3147e5ca/imgi-1-533658112-1338949804900465-8033016254868742107-n.jpg"
              alt="De to søstre i butikken"
              className="relative rounded-2xl border border-choc-dark/10 shadow-md w-full object-cover aspect-[4/3]"
            />
          </div>
          <div className="lg:col-span-7 flex flex-col gap-6">
            <span className="text-xs font-sans uppercase tracking-[0.2em] text-berry-accent font-bold">
              Mød søstrene bag
            </span>
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-choc-dark leading-tight">
              To søstre med fokus på godt håndværk og det søde liv
            </h2>
            <p className="text-base text-choc-dark/80 leading-relaxed font-sans">
              Chokolenten ApS drives af to passionerede søstre, der har sat sig for at bringe det fineste chokoladehåndværk til Hanstholm. Hver dag står vi i vores eget chokoladeri og ruller, tempererer og bager med de bedste råvarer, vi kan få fingrene i. For os er det gode håndværk og den kompromisløse kvalitet altid i centrum.
            </p>
            <p className="text-base text-choc-dark/80 leading-relaxed font-sans">
              Udover vores håndlavede chokolader, kager og store, lækre Thy Kukies, finder du også et stort udvalg af gavekurve og specialiteter i butikken. Vi laver dem til private og erhverv i alle størrelser og sammensætninger. Du kan vælge blandt vores færdige udvalg eller bygge din helt egen personlige gavekurv eller gaveæske. Kig også forbi vores hyggelige café, hvor du kan nyde en god kop kaffe og lidt sødt i stemningsfulde omgivelser.
            </p>
            <div>
              <Link
                to="/om-os"
                className="inline-flex items-center gap-2 text-berry-accent hover:text-berry-accent/80 font-sans font-semibold transition-colors group cursor-pointer"
              >
                Læs hele vores historie
                <i className="fa-solid fa-arrow-right transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* 3. PRODUKTKATEGORIER */}
      <section className="bg-cream-light py-20 border-y border-choc-dark/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-12">
          <div className="text-center max-w-2xl mx-auto flex flex-col gap-4">
            <span className="text-xs font-sans uppercase tracking-[0.2em] text-berry-accent font-bold">
              Udforsk vores verden
            </span>
            <h2 className="text-3xl sm:text-4xl font-serif font-bold text-choc-dark">
              Hvad frister i dag?
            </h2>
            <p className="text-sm sm:text-base text-choc-dark/70 font-sans">
              Klik dig ind på vores kategorier for at se et udvalg af de lækkerier, vi bager og laver i butikken hver dag. Vi udforsker og prøver hele tiden nyt af – så kig endelig ind i butikken eller følg med på vores sociale medier!
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/produkter/${cat.slug}`}
                className="group flex flex-col bg-cream-bg rounded-2xl border border-choc-dark/10 overflow-hidden shadow-sm hover:shadow-md hover:border-berry-accent/30 transition-all duration-300 h-full"
              >
                <div className="aspect-square overflow-hidden bg-choc-dark/5 relative">
                  <img
                    src={cat.image.replace('https://assets.auxodev.dk/assets/', 'https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=85,format=auto/assets/')}
                    alt={cat.name}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="p-5 flex flex-col gap-2 flex-grow">
                  <h3 className="font-serif font-bold text-lg text-choc-dark group-hover:text-berry-accent transition-colors">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-choc-dark/70 leading-relaxed font-sans flex-grow">
                    {cat.desc}
                  </p>
                  <span className="text-xs font-sans font-semibold text-berry-accent mt-2 flex items-center gap-1 group-hover:translate-x-1 transition-transform">
                    Se udvalg <i className="fa-solid fa-chevron-right text-[10px]" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* 4. GALLERI PREVIEW */}
      {galleryImages.length > 0 && (
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-12">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
            <div className="flex flex-col gap-3">
              <span className="text-xs font-sans uppercase tracking-[0.2em] text-berry-accent font-bold">
                Visuel nydelse
              </span>
              <h2 className="text-3xl sm:text-4xl font-serif font-bold text-choc-dark">
                Lækkerier fanget på kamera
              </h2>
            </div>
            <Link
              to="/galleri"
              className="inline-flex items-center gap-2 text-berry-accent hover:text-berry-accent/80 font-sans font-semibold transition-colors group cursor-pointer"
            >
              Se hele galleriet
              <i className="fa-solid fa-arrow-right transition-transform group-hover:translate-x-1" />
            </Link>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {galleryImages.slice(0, 4).map((img, index) => (
              <div
                key={index}
                onClick={() => setLightboxIndex(index)}
                className="aspect-square rounded-2xl overflow-hidden border border-choc-dark/10 shadow-sm cursor-pointer group relative"
              >
                <img
                  src={img.replace('https://assets.auxodev.dk/assets/', 'https://assets.auxodev.dk/cdn-cgi/image/width=500,quality=85,format=auto/assets/')}
                  alt={`Galleri preview ${index + 1}`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-choc-dark/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                  <i className="fa-regular fa-eye text-white text-2xl" />
                </div>
              </div>
            ))}
          </div>

          {lightboxIndex !== null && (
            <GalleryLightbox
              images={galleryImages}
              currentIndex={lightboxIndex}
              onClose={() => setLightboxIndex(null)}
              onPrev={() => setLightboxIndex((lightboxIndex - 1 + galleryImages.length) % galleryImages.length)}
              onNext={() => setLightboxIndex((lightboxIndex + 1) % galleryImages.length)}
            />
          )}
        </section>
      )}

      {/* 6. SOCIAL SEKTION (INSTAGRAM/FACEBOOK PREVIEW) */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col gap-12">
        <div className="text-center max-w-2xl mx-auto flex flex-col gap-4">
          <span className="text-xs font-sans uppercase tracking-[0.2em] text-berry-accent font-bold">
            Følg vores rejse
          </span>
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-choc-dark">
            Chokolenten på sociale medier
          </h2>
          <p className="text-sm sm:text-base text-choc-dark/70 font-sans">
            Vi deler dagligt ud af vores søde kreationer, hverdagen i butikken og sæsonens nyheder. Følg os for masser af lækker inspiration!
          </p>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4">
          <a
            href="https://www.instagram.com/chokolenten/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-[#833AB4] via-[#FD1D1D] to-[#F56040] text-white font-sans font-semibold px-6 py-3.5 rounded-xl transition-all hover:scale-102 shadow-md cursor-pointer"
          >
            <i className="fa-brands fa-instagram text-lg" />
            Følg os på Instagram
          </a>
          <a
            href="https://www.facebook.com/chokolenten"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#1877F2] text-white font-sans font-semibold px-6 py-3.5 rounded-xl transition-all hover:scale-102 shadow-md cursor-pointer"
          >
            <i className="fa-brands fa-facebook text-lg" />
            Følg os på Facebook
          </a>
        </div>
      </section>





      {/* 7. KONTAKT PREVIEW & INFO */}
      <section className="bg-choc-dark text-cream-light py-20 border-t border-choc-medium/30">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 flex flex-col gap-6">
              <span className="text-xs font-sans uppercase tracking-[0.2em] text-berry-light font-bold">
                Kig forbi eller ring
              </span>
              <h2 className="text-3xl sm:text-4xl font-serif font-bold text-cream-light leading-tight">
                Har du spørgsmål eller vil du høre mere?
              </h2>
              <p className="text-base text-cream-light/80 leading-relaxed font-sans">
                Vi står altid klar til at hjælpe dig. Du er mere end velkommen til at ringe, sende en e-mail eller kigge forbi butikken i Hanstholm.
              </p>
              
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-4 border-t border-cream-light/10 pt-8">
                <div className="flex flex-col gap-1">
                  <span className="text-xs font-sans uppercase tracking-wider text-caramel-light font-semibold">Adresse</span>
                  <p className="text-sm font-medium">Bytorvet 30, 7730 Hanstholm</p>
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-xs font-sans uppercase tracking-wider text-caramel-light font-semibold">Telefon</span>
                  <a href="tel:+4597960600" className="text-sm font-medium hover:text-berry-light transition-colors whitespace-nowrap">
                    97 96 06 00
                  </a>
                </div>
                <div className="flex flex-col gap-1">
                  <span className="text-xs font-sans uppercase tracking-wider text-caramel-light font-semibold">E-mail</span>
                  <a href="mailto:info@chokolenten.dk" className="text-sm font-medium hover:text-berry-light transition-colors whitespace-nowrap">
                    info@chokolenten.dk
                  </a>
                </div>
              </div>
            </div>
            
            <div className="lg:col-span-5 flex flex-col gap-4 bg-cream-light text-choc-dark p-8 rounded-2xl border border-choc-dark/10 shadow-xl">
              <h3 className="font-serif font-bold text-2xl mb-2">
                Send os en besked
              </h3>
              <p className="text-sm text-choc-dark/70 font-sans mb-4">
                Udfyld vores hurtige kontaktformular, så vender vi tilbage til dig så hurtigt som muligt!
              </p>
              <Link
                to="/kontakt"
                className="w-full text-center bg-berry-accent hover:bg-berry-accent/90 text-white font-sans font-semibold py-4 px-6 rounded-xl transition-colors shadow-md hover:shadow-lg cursor-pointer"
              >
                Gå til kontaktformular
              </Link>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}
